var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemovePhoto(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.211,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.209 14h12",
    stroke: "#1B264F",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.543 14v-1.333a1.333 1.333 0 011.333-1.334h2.667a1.333 1.333 0 011.333 1.334V14m2 0v9.333a1.334 1.334 0 01-1.333 1.334h-6.667a1.333 1.333 0 01-1.333-1.334V14h9.333zM19.543 17.333v4M16.877 17.333v4",
    stroke: "#1B264F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default __webpack_public_path__ + "media/photographerOnboarding/remove-photo-284fe4e0.svg";
export { SvgRemovePhoto as ReactComponent };